en:
  variables:
    levels:
      - Easy
      - Average
      - Hot
    target:
      boy: Boy
      girl: Girl

ru:
  variables:
    levels:
      - Легкий
      - Средний
      - Горячий
    target:
      boy: Парня
      girl: Девушки

de:
  variables:
    levels:
      - Einfach
      - Durchschnitt
      - Heiß
    target:
      boy: Kerl
      girl: Mädchen

es:
  variables:
    levels:
      - Fácil
      - Promedio
      - Caliente
    target:
      boy: chico
      girl: Chicas

fr:
  variables:
    levels:
      - Facile
      - Moyenne
      - Chaud
    target:
      boy: gars
      girl: Filles
